import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=66264630&"
import script from "./CategoryForm.vue?vue&type=script&lang=ts&"
export * from "./CategoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CategoryForm.vue"
export default component.exports